import { extractData } from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import { InstructorsPageSchema } from "./schemas";
import type { InstructorsPageType } from "./types";

export const mapDtoToInstructorsPage = (dto: unknown): InstructorsPageType => {
  const parsed = safeParseWithFallback(
    InstructorsPageSchema,
    dto,
    "mapDtoToInstructorsPage",
  );

  return extractData(parsed, dto, dto as InstructorsPageType);
};
